if (!customElements.get('lookbook-detail')) {
  customElements.define(
    'lookbook-detail',
    class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-lookbook-add]');
        this.status = this.querySelector('[data-status]');
        this.lookHandle = this.button?.dataset.lookHandle || '';

        this.button?.addEventListener('click', () => this.addLook());
      }

      /**
       * Verzamelt per product de gekozen variant.
       * Elk product heeft een eigen radiogroep, dus één :checked per product.
       * De _look en _look_group properties zijn verborgen voor de klant
       * (ze beginnen met een underscore) maar leesbaar voor kortingslogica.
       */
      getSelection() {
        const inputs = this.querySelectorAll('[data-lookbook-variant]:checked');
        const group = `${this.lookHandle}-${Date.now()}`;

        return [...inputs].map((input) => ({
          id: Number(input.value),
          quantity: 1,
          properties: {
            _look: this.lookHandle,
            _look_group: group
          }
        }));
      }

      /**
       * Controleert of voor élk product een maat gekozen is.
       */
      isComplete() {
        const productCount = this.querySelectorAll('.mp-lookbook__product').length;
        const selectedCount = this.querySelectorAll('[data-lookbook-variant]:checked').length;
        return productCount > 0 && productCount === selectedCount;
      }

      setStatus(message) {
        if (this.status) this.status.textContent = message;
      }

      async addLook() {
        if (!this.isComplete()) {
          this.setStatus('kies eerst een maat voor elk artikel');
          setTimeout(() => this.setStatus(''), 3000);
          return;
        }

        const items = this.getSelection();
        if (!items.length) return;

        this.button.classList.add('is-loading');
        this.button.disabled = true;
        this.setStatus('…');

        const root = window.Shopify?.routes?.root || '/';

        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items })
          });

          const data = await response.json();

          if (!response.ok) {
            // Shopify geeft bij een 422 een leesbare omschrijving terug,
            // bijvoorbeeld wanneer een maat intussen uitverkocht is.
            throw new Error(data.description || data.message || 'Toevoegen mislukt');
          }

          this.setStatus('toegevoegd');
          this.notifyTheme(data);
          setTimeout(() => this.setStatus(''), 2500);
        } catch (error) {
          console.error('Lookbook — toevoegen mislukt:', error);
          this.setStatus(error.message || 'probeer opnieuw');
          setTimeout(() => this.setStatus(''), 4000);
        } finally {
          this.button.classList.remove('is-loading');
          this.button.disabled = false;
        }
      }

      /**
       * Palo Alto luistert op events met het voorvoegsel 'theme:cart:'.
       * refresh haalt de nieuwe winkelmandinhoud op, open schuift de drawer uit.
       */
      notifyTheme(data) {
        document.dispatchEvent(
          new CustomEvent('theme:cart:refresh', {
            bubbles: true,
            detail: { cart: data }
          })
        );

        document.dispatchEvent(
          new CustomEvent('theme:cart:open', { bubbles: true })
        );
      }
    }
  );
}
